import { HTMLAttributes } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
  message: any;
}

export default function FormError({ message, ...rest }: Props) {
  //display first error message only
  return (
    <div {...rest} aria-live="polite" aria-atomic="true">
      {message && message.length>0 &&
        
          <p className="mt-2 text-sm text-red-500" key={message[0]}>
            {message[0]}
          </p>
        }
    </div>
  );
 
}
